module.exports = __webpack_public_path__ + "static/media/reviewsBg.c6e3670d.jpg";